
    import "src/app/AppSeller/SettingsPage/Support/index.module.scss?farm_css_modules";
    
    export default {"headContainer": `headContainer-657a64c3`,"supportImg": `supportImg-657a64c3`,"supportImgParentDiv": `supportImgParentDiv-657a64c3`}
    